import {
  useState,
  useDeferredValue,
  useTransition,
  useEffect,
  useCallback
} from 'react';

export const useDeferredSearchQuery = () => {
  const [search, setSearchReal] = useState('');

  const query = useDeferredValue(search).trim();
  const [, startTransition] = useTransition();
  /** stored input value when user parse typing */
  const [finalQuery, setFinalQuery] = useState('');

  useEffect(() => {
    if (finalQuery !== query) {
      const timeout = setTimeout(() => {
        setFinalQuery(query);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [query]);

  const setSearch = useCallback(
    (val) => {
      const realval = typeof val === 'string' ? val : val.target?.value || '';
      startTransition(() => {
        setSearchReal(realval);
      });
    },
    [setSearchReal]
  );

  return {
    setSearch,
    /** deferred value */
    query,
    /** real value */
    search,
    /** stored input value when user parse typing */
    finalQuery
  };
};
